"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const BreadcrumbsCompositor_vue_1 = __importDefault(require("./BreadcrumbsCompositor.vue"));
const SectionInnerHeader_vue_1 = __importDefault(require("./SectionInnerHeader.vue"));
const CategoryFilterList_vue_1 = __importDefault(require("./CategoryFilterList.vue"));
const ModelCompositorCategory_1 = __importDefault(require("../abstract/models/ModelCompositorCategory"));
const ModelCompositorCategorys_1 = __importDefault(require("../abstract/models/ModelCompositorCategorys"));
const CropFilterList_vue_1 = __importDefault(require("./CropFilterList.vue"));
let CompositionViewHeader = class CompositionViewHeader extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentCategory = this.initCurrentCategory;
        this.modelCategories = new ModelCompositorCategorys_1.default(this.categories);
    }
    updateModelCategories() {
        this.modelCategories = new ModelCompositorCategorys_1.default(this.categories);
    }
    get allCropsWithCount() {
        const currentCategory = new ModelCompositorCategory_1.default(this.category, false);
        return currentCategory.getAllCropsWithCount();
    }
    emitCurrentCategory(currentCategory) {
        this.currentCategory = currentCategory;
        this.$emit('currentCategory', currentCategory);
    }
    emitCropFilterId(cropId) {
        this.$emit('cropFilterId', cropId);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], CompositionViewHeader.prototype, "categories", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: ModelCompositorCategory_1.default, default: {} })
], CompositionViewHeader.prototype, "category", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CompositionViewHeader.prototype, "initCurrentCategory", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('categories')
], CompositionViewHeader.prototype, "updateModelCategories", null);
CompositionViewHeader = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BreadcrumbsCompositor: BreadcrumbsCompositor_vue_1.default,
            SectionInnerHeader: SectionInnerHeader_vue_1.default,
            CategoryFilterList: CategoryFilterList_vue_1.default,
            CropFilterList: CropFilterList_vue_1.default,
            Separator: bmk_ui_framework_1.Separator,
        },
    })
], CompositionViewHeader);
exports.default = CompositionViewHeader;
